import { combineReducers } from 'redux';

import { reducer as order } from './State/order';
import { reducer as fetching } from './State/fetching';
import { reducer as editable } from './State/editable';
import { reducer as showOrderModal } from './State/showOrderModal';
import { reducer as showEmailModal } from './State/showEmailModal';
import { reducer as showClientSiteModal } from './State/showClientSiteModal';
import { reducer as showClientContactModal } from './State/showClientContactModal';
import { reducer as projectEditorModal } from './State/projectEditorModal';
import { reducer as selectedOrderItemIds } from './State/selectedOrderItemIds';
import { reducer as subOrderModal } from './State/subOrderModal';
import { reducer as procurementItems } from './State/procurementItems';
import { reducer as deletedProcurementItemIds } from './State/deletedProcurementItemIds';
import { reducer as showProcurementItemModal } from './State/showProcurementItemModal';
import { reducer as procurementItemForEdit } from './State/procurementItemForEdit';
import { reducer as showCatalogPicker } from './State/showCatalogPicker';

export default combineReducers({
  order,
  fetching,
  editable,
  showOrderModal,
  showEmailModal,
  showClientSiteModal,
  showClientContactModal,
  projectEditorModal,
  selectedOrderItemIds,
  subOrderModal,
  procurementItems,
  deletedProcurementItemIds,
  showProcurementItemModal,
  procurementItemForEdit,
  showCatalogPicker,
})
